/* Riora trial offer cards — independent per-card buttons.
   Picking any option replaces any other Riora trial line (and its gifts)
   already in the cart, so a shopper never carries two competing trial
   offers at once. Adapted from assets/riora-tbyb.js, which this does not
   modify or depend on. */
(function () {
  function init(root) {
    if (root.dataset.toReady) return;
    root.dataset.toReady = '1';
    var redirect = root.dataset.redirect === 'cart' ? '/cart' : '/checkout';

    root.querySelectorAll('[data-riora-to-cta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var card = btn.closest('.riora-to__card');
        var errorEl = card ? card.querySelector('[data-riora-to-error]') : null;
        var vid = parseInt(btn.dataset.variant, 10);
        if (!vid) return;

        var main = { id: vid, quantity: 1, properties: { _riora_offer: btn.dataset.key || 'trial' } };
        if (btn.dataset.plan) main.selling_plan = parseInt(btn.dataset.plan, 10);
        var gifts = (btn.dataset.gifts || '').split(',').map(function (g) { return parseInt(g, 10); }).filter(function (g) { return g > 0; });

        var allButtons = root.querySelectorAll('[data-riora-to-cta]');
        allButtons.forEach(function (b) { b.disabled = true; });
        if (errorEl) errorEl.hidden = true;
        var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return { items: [] }; })
          .then(function (cart) {
            var items = cart.items || [];
            var trialVariants = {};
            var updates = {};
            items.forEach(function (it) {
              if (it.properties && it.properties._riora_offer) { trialVariants[String(it.variant_id)] = true; updates[it.key] = 0; }
            });
            items.forEach(function (it) {
              var sp = it.properties && it.properties._riora_gift_for;
              if (!sp) return;
              var sponsors = String(sp).split(',').filter(Boolean);
              var others = sponsors.filter(function (s) { return !trialVariants[s]; });
              if (sponsors.length && !others.length) updates[it.key] = 0;
            });
            var clear = fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: updates, attributes: { riora_offer: btn.dataset.key || 'trial' } }) })
              .then(function (r) { return r.json(); });
            return clear.then(function (c) {
              var inCart = {};
              (c.items || []).forEach(function (it) { inCart[it.variant_id] = true; });
              var add = gifts.filter(function (g) { return !inCart[g]; }).map(function (g) {
                return { id: g, quantity: 1, properties: { _riora_gift_for: String(vid) } };
              });
              add.push(main);
              return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: add }) });
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed ' + res.status);
            window.location.href = redirect;
          })
          .catch(function (e) {
            console.error('Riora trial offer:', e);
            allButtons.forEach(function (b) { b.disabled = false; });
            if (errorEl) errorEl.hidden = false;
          });
      });
    });
  }
  function boot() { document.querySelectorAll('[data-riora-to]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
